/* eslint-disable */

import { Link } from "@reach/router"
import React, { useEffect, useMemo, useState } from "react"
import { useLocation } from "@reach/router"
import axios from "axios"

const OrderHistoryCard = ({ processedAt, id, lineItems, name }: Order) => {
  const inputString = name
  const formattedOrderNumber = inputString.match(/\d+/)[0]

  const location = useLocation()
  const [shopifyOrder, setShopifyOrder] = useState(null)

  const [
    allProductsVariantsWithMetaFields,
    setAllProductsVariantsWithMetaFields,
  ] = useState([])

  const hasItems = useMemo(() => {
    return !!lineItems?.edges?.filter(item => item?.node?.variant?.image?.url)
      ?.length
  }, [lineItems])

  const getProductById = async (
    id,
    productId,
    variant_id,
    variant_product_id,
  ) => {
    return await axios
      .post("/.netlify/functions/get-product-by-id", {
        id,
        product_id: productId,
        variant_id,
        variant_product_id,
      })
      .then(res => {
        return res.data
      })
      .catch(err => {
        return {}
      })
  }

  const getOrderDetails = async () => {
    axios
      .post(
        "/.netlify/functions/shopifyGetOrderByName",
        JSON.stringify({ data: { userOrderNumber: formattedOrderNumber } }),
      )
      .then(async res => {
        const lineItemsPromises =
          res.data.data.orderData.orders[0].line_items.map(
            async (lineItem: any) => {
              const response = await getProductById(
                lineItem.product_id,
                `gid://shopify/Product/${lineItem.product_id}`,
                lineItem.variant_id,
                `gid://shopify/ProductVariant/${lineItem.variant_id}`,
              )
              return response
            },
          )
        const response = await Promise.all(lineItemsPromises)
        setAllProductsVariantsWithMetaFields(response)
        if (res.data.data.orderData.orders.length === 1) {
          const orderData = res.data.data.orderData.orders[0]
          setShopifyOrder(orderData)
        } else {
          console.log("error")
        }
      })
      .catch(err => {
        return "Server API Get Request Failed"
      })
  }
  useEffect(() => {
    getOrderDetails()
  }, [id])

  return (
    <Link
      to={`/account/order-history/order?id=${id}/${
        location.search ? location.search : ""
      }`}
      className="lg:max-w-[350px] w-full bg-white py-6 px-5 relative"
    >
      <div>
        <h1 className="mb-0 font-extrabold text-base">Purchase Date:</h1>
        <p className="mb-0 font-normal text-sm">{processedAt}</p>
        <div className="space-x-2 flex">
          <p className="text-12 text-[#828282] mb-0">Return</p>
          <p className="text-12 text-[#828282] mb-0">Cancel/Edit Order</p>
          <p className="text-12 text-[#828282] mb-0">Download Invoice</p>
        </div>
        <h1 className="mb-0 mt-3 font-extrabold text-base">Order Number:</h1>
        <p className="mb-0 font-normal text-sm">{name}</p>
        <>
          <h1 className="mb-0 mt-3 font-extrabold text-base">Items</h1>
          {allProductsVariantsWithMetaFields?.length > 0 ? (
            <div className="flex items-center space-x-2 mt-2 overflow-x-auto h -[200px]">
              {allProductsVariantsWithMetaFields?.map(item => (
                <div>
                  <div
                    // key={idx}
                    className="border-2 border-[#CFCFCF] px-4 py-2 flex justify-center items-center"
                  >
                    <img
                      src={item?.image?.src}
                      alt={item?.image?.alt}
                      className="max-w-[64px] object-cover mb-0"
                    />
                  </div>
                  <div className=" text-center">
                    {item?.variants?.[0]?.metafields[0]?.value && (
                      <>
                        <div className="text-[9px]">Preordered item:</div>
                        <div className="text-[9px] leading-[2px] text-[#c99e1a]">
                          {" "}
                          {item?.variants?.[0]?.metafields[0]?.value}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <h1 className="!text-[10px]"> No items to show. </h1>
          )}
        </>
      </div>
    </Link>
  )
}

export default OrderHistoryCard
